// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishListGroupItem-imageContent-FO_84 {
    width: 100%;
    height: 100%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 59%;
    background-color: var(--common-gray-bg-color);
    border-radius: 6px;
}

.WishListGroupItem-defaultImageCss-Ljx8q {
    background-size: 54px;
}`, "",{"version":3,"sources":["webpack://./src/components/WishLists/WishListGroupItem/WishListGroupItem.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".imageContent {\n    width: 100%;\n    height: 100%;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding-top: 59%;\n    background-color: var(--common-gray-bg-color);\n    border-radius: 6px;\n}\n\n.defaultImageCss {\n    background-size: 54px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageContent": `WishListGroupItem-imageContent-FO_84`,
	"defaultImageCss": `WishListGroupItem-defaultImageCss-Ljx8q`
};
module.exports = ___CSS_LOADER_EXPORT___;
